export default __webpack_public_path__ + "static/media/iphone-login.6088b81d.png";